import React from "react";
import PropTypes from "prop-types";
import { IndustryReport } from "../../../locales/en";
import { industryViewType, countries } from "../../../utils/data/data";
import styles from "./../../../assets/scss/custom.module.scss";
import ".././reportStyle.scss";
import { MONTH, QUARTER, YEAR } from "../../../utils/constants/appConstants";
import {
  getDataTypes,
  getPeriods,
  getYears_periods
} from "../../../utils/getDropdownOptions";

const IndustrySectorFilter = (props) => {
  const { handleInputChange, values, loading } = props;

  return (
    <>
      <div className="filter d-flex align-self-center main-filter-bar flex-wrap">
        <div className="d-flex align-items-center mb-1 mt-1">
          <label htmlFor="view" className={`${styles.selectStatusLabel}`}>
            {IndustryReport?.filter.viewTye}
          </label>
          <select
            name="viewType"
            className={`${styles.selectShowStatus} pe-5`}
            value={values.viewType}
            onChange={handleInputChange}
            disabled={loading}
          >
            {industryViewType.map((filter) => (
              <option key={filter.id} value={filter.value}>
                {filter.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="d-flex filter_download align-items-center mb-1 mt-1">
        <div className="d-flex">
          <label
            htmlFor="Status-sort"
            className={`${styles.selectStatusLabel} d-flex align-self-center `}
          >
            {IndustryReport?.filter.periods}
          </label>
          <select
            name="period"
            className={`${styles.selectShowStatus}`}
            value={values.period}
            onChange={handleInputChange}
            disabled={loading}
          >
            {values.viewType === MONTH &&
              getPeriods.map((filter) => (
                <option key={filter.id} value={filter.value}>
                  {filter.label}
                </option>
              ))}
            {values.viewType === QUARTER &&
              getPeriods?.map((filter) => (
                <option key={filter.id} value={filter.value}>
                  {filter.label}
                </option>
              ))}
            {values.viewType === YEAR &&
              getYears_periods?.map((filter) => (
                <option key={filter.id} value={filter.value}>
                  {filter.label}
                </option>
              ))}
          </select>
        </div>
      </div>

      <div className="d-flex filter_download align-items-center mb-1 mt-1">
        <div className="d-flex">
          <label
            htmlFor="Status-sort"
            className={`${styles.selectStatusLabel} d-flex align-self-center `}
          >
            {IndustryReport?.filter.selectCountry}
          </label>
          <select
            name="countrySelect"
            className={`${styles.selectShowStatus}`}
            value={values.countrySelect}
            onChange={handleInputChange}
            disabled={loading}
          >
            {countries.map((filter) => (
              <option key={filter.id} value={filter.value}>
                {filter.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="d-flex filter_download align-items-center mb-1 mt-1">
        <div className="d-flex">
          <label
            htmlFor="Status-sort"
            className={`${styles.selectStatusLabel} d-flex align-self-center `}
          >
            {IndustryReport?.filter.selectDataType}
          </label>
          <select
            name="dataType"
            className={`${styles.selectShowStatus}  `}
            value={values.dataType}
            onChange={handleInputChange}
            disabled={loading}
          >
            {getDataTypes?.map((filter) => (
              <option key={filter.id} value={filter.value}>
                {filter.label}
              </option>
            ))}
          </select>
        </div>
      </div>
    </>
  );
};

IndustrySectorFilter.propTypes = {
  values: PropTypes.object,
  handleInputChange: PropTypes.func,
  loading: PropTypes.bool
};
export default IndustrySectorFilter;
